import { EValidationMessageType, ValidationMessageProps } from '../components/ValidationMessage';

// Tests //

export enum EValidationTestType {
  isTrue = 'isTrue',
  hasValue = 'hasValue',
  hasAnyValue = 'hasAnyValue',
  isPasswordMatch = 'isPasswordMatch',
  isEmail = 'isEmail',
  isPhoneNumber = 'isPhoneNumber',
  isPassword = 'isPassword',
  isPin = 'isPin',
  isDate = 'isDate',
  isFirstDayOfTheMonth = 'isFirstDayOfTheMonth',
  isLastDayOfTheMonth = 'isLastDayOfTheMonth',
  isBeschaftingungsgrad = 'isBeschaftingungsgrad',
  isNumber = 'isNumber',
  isPositive = 'isPositive',
  isText = 'isText',
  isDegree = 'isDegree',
}

// Test Messages //
// @ts-ignore
export const VALIDATION_MESSAGE: IDictionary<ValidationMessageProps> = {
  hasValue: {
    message: 'Pflichtfeld darf nicht leer sein',
    type: EValidationMessageType.Error,
  },
  hasAnyValue: {
    message: 'Pflichtfeld darf nicht leer sein',
    type: EValidationMessageType.Error,
  },
  isPasswordMatch: {
    message: 'Passwörter stimmen nicht überein', // tslint:disable-line
    type: EValidationMessageType.Error,
  },
  isEmail: {
    message: 'E-Mail ist ungültig',
    type: EValidationMessageType.Error,
  },
  isPhoneNumber: {
    message: 'Telefonnummer ist ungültig',
    type: EValidationMessageType.Error,
  },
  isPin: {
    message: 'PIN ist ungültig',
    type: EValidationMessageType.Error,
  },
  isPassword: {
    message: 'Das Passwort muss mindestens 8 Zeichen lang sein und muss mindestens 1 Sonderzeichen enthalten.',
    type: EValidationMessageType.Error,
  },
  isDate: {
    message: 'Bitte korrektes Datumsformat “DD.MM.YYYY” verwenden',
    type: EValidationMessageType.Error,
  },
  isFirstDayOfTheMonth: {
    message: 'Please select the first day of the month',
    type: EValidationMessageType.Error,
  },
  isLastDayOfTheMonth: {
    message: 'Please select the last day of the month',
    type: EValidationMessageType.Error,
  },
  isBeschaftingungsgrad: {
    message: 'Beschäftigungsgrad in Prozent eingeben. (0 - 140%)',
    type: EValidationMessageType.Error,
  },
  isNumber: {
    message: 'Please do not enter letters.',
    type: EValidationMessageType.Error,
  },
  isPositive: {
    message: 'Number between 0 and 100.',
    type: EValidationMessageType.Error,
  },
};
